import React from "react";
import clsx from "clsx";
import { formatAmount } from "../../shared/helpers/formatters";
import "../../afs-walkthrough.css";

const fmt = formatAmount;

function SummaryView({ balanceSheet, incomeStatement }) {
	return (
		<div className="afs-summary__grid">
			<div className="afs-summary__panel">
				<div className="afs-summary__panel-header">Balance Sheet</div>
				<div className="afs-summary__panel-body">
					{balanceSheet.sections.map(s => (
						<div key={s.name} className="afs-summary__section">
							<div className="afs-summary__section-label">{s.name}</div>
							{s.accounts.map((a, i) => (
								<div key={i} className="afs-summary__account"><span>{a.description}</span><span>{fmt(a.current)}</span></div>
							))}
							<div className="afs-summary__total"><span>Total {s.name}</span><span>{fmt(s.totalCurrent)}</span></div>
						</div>
					))}
					<div className="afs-summary__grand-total"><span>Total Assets</span><span>{fmt(balanceSheet.totalAssets?.current)}</span></div>
					<div className="afs-summary__grand-total"><span>Total Liabilities &amp; Equity</span><span>{fmt(balanceSheet.totalLiabilitiesAndEquity?.current)}</span></div>
				</div>
			</div>
			<div className="afs-summary__panel">
				<div className="afs-summary__panel-header">Income Statement</div>
				<div className="afs-summary__panel-body">
					{incomeStatement.sections.map(s => (
						<div key={s.name} className="afs-summary__section">
							<div className="afs-summary__section-label">{s.name}</div>
							{s.accounts.map((a, i) => (
								<div key={i} className="afs-summary__account"><span>{a.description}</span><span>{fmt(a.current)}</span></div>
							))}
							<div className="afs-summary__total"><span>Total {s.name}</span><span>{fmt(s.totalCurrent)}</span></div>
						</div>
					))}
					<div className={clsx(incomeStatement.netIncome?.current >= 0 ? "afs-summary__net-income--positive" : "afs-summary__net-income--negative")}>
						<span>Net Income (Loss)</span><span>{fmt(incomeStatement.netIncome?.current)}</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default SummaryView;
